import declare from "dojo/_base/declare";
import { CallMethod } from "csi/xml/CallMethod";
import New from "csi/table/New";
import xml from "csi/xml";

const NewSizeCurve= declare(New, {
	
	/**
	 * @override
	 * Add the matrix values and the size range to the call
	 */
	toWriterRequest() {
		const call = this.inherited<CallMethod>(arguments);
		const form = this.popupView as any;
		const matrixValues = form.matrix.get("value").flat(1);
		call.addParameter("QuantityPerSize", "int"+xml.ATTR_LIST, matrixValues);
		call.addParameter("AddURL", xml.ATTR_REF, this.getParent().$URL);
		return call;
	},
});


export = NewSizeCurve;